module.exports = __webpack_public_path__ + "static/icons/icon-unlock--primary-cd0e5bbcd771ae1b80fab3840ceb5bc2.svg";